import type { AutoCompleteItem } from '../../../../components/react-hook-form/AutoCompleteItem.d';
import type { Phrases } from '../../common/Phrases.d';

import React from 'react';
import { useFormContext } from '../../../../components/react-hook-form/FormContext';
import { useWatch } from 'react-hook-form';
import { AutoComplete } from '../../../../components/react-hook-form/AutoComplete';
import {
	SERVICES_FIELD_NAME,
	SERVICES_WHERE,
} from '../constants';
import {
	COMMON_FREETEXT_FIELD_NAME,
	WHERE_LEGEND_ID,
} from '../../common/constants';

const OTHER: string[] = [
	SERVICES_WHERE.OTHER,
];

export const WhereAutoComplete = ({
	descriptionId,
	errorSummaryLabel,
	items,
	phrases,
}: {
	descriptionId: string;
	errorSummaryLabel: string;
	items: AutoCompleteItem[];
	phrases: Phrases;
}): React.JSX.Element => {
	const { control, setValue } = useFormContext();

	const where = useWatch({ control, name: SERVICES_FIELD_NAME.WHERE }) as string;

	React.useEffect(() => {
		if (!where || !OTHER.includes(where)) {
			// Yes, empty string can be set on optional text fields.
			setValue(COMMON_FREETEXT_FIELD_NAME.WHERE_OTHER, '', { shouldValidate: true });
		}
	}, [where]);

	return (
		<AutoComplete
			aria-labelledby={WHERE_LEGEND_ID}
			aria-describedby={descriptionId}

			// hideLabel also hides description
			// description={phrases['notificationForm.services.whereField.description']}

			errorSummaryLabel={errorSummaryLabel}
			fullWidth={false}
			hideLabel

			// hideLabel also hides infoText icon
			// infoText={
			// 	<Span
			// 		dangerouslySetInnerHTML={{ __html: sanitizeHtml(phrases[
			// 			'notificationForm.services.whereField.infoText.html'
			// 		])}}
			// 	/>
			// }

			label={
				phrases['notificationForm.services.whereField.label']
				// WARNING Passing ReactNode rather than string
				// Causes aria-label="[object Object]" label="[object Object]"
				//
				// <Legend className='font-semibold inline-block text-xl'>
				// 	{phrases['notificationForm.services.whereField.label']}
				// </Legend>
			}
			name={SERVICES_FIELD_NAME.WHERE}
			items={items}
		/>
	);
};
